import ChildPage from '@/views/ChildPage.vue'
import useChildStore from '@/stores/child'
import type { RouteLocationNamedRaw } from 'vue-router'

function savePreviuosRoute(to: RouteLocationNamedRaw, from: RouteLocationNamedRaw): void {
  if (from.name === 'Home') {
    const childStore = useChildStore()
    childStore.updateIsPrevRouteHomePage(from.name === 'Home')
  }
}

export default [
  {
    path: '/:childEditionId',
    props: true,
    name: 'ChildPage',
    component: ChildPage,
    meta: {
      title: 'Wybór dziecka - Ścieżka Wyboru Dzieci',
      metaTags: [{ name: 'robots', content: 'noindex' }]
    },
    beforeEnter: [savePreviuosRoute]
  },
  {
    path: '/:childEditionId/:childEditionRetentionHash',
    props: true,
    name: 'ChildPageRetention',
    component: ChildPage,
    meta: {
      title: 'Wybór dziecka - Ścieżka Wyboru Dzieci',
      metaTags: [{ name: 'robots', content: 'noindex' }]
    },
    beforeEnter: [savePreviuosRoute]
  }
]
